import React from 'react';
import { NavLink } from 'react-router-dom';

const navItems = [
  { label: 'Deep Index', to: '/pipeline', key: '01', hint: 'find + verify' },
  { label: 'My Info', to: '/profile', key: '02', hint: 'matching vault' },
  { label: 'Drafts', to: '/requests', key: '03', hint: 'review + send' }
];

const Sidebar: React.FC = () => {
  return (
    <aside className="sidebar">
      <div className="brand">
        <div className="brandMark">PR</div>
        <div>
          <strong>Privacy Indexer</strong>
          <span>Exact-source removal</span>
        </div>
      </div>

      <nav className="navList" aria-label="Main navigation">
        {navItems.map((item) => (
          <NavLink key={item.to} to={item.to} className={({ isActive }) => `navItem ${isActive ? 'active' : ''}`}>
            <span className="navGlyph">{item.key}</span>
            <span><strong>{item.label}</strong><small>{item.hint}</small></span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebarCard">
        <span className="eyebrow">Workflow</span>
        <strong>Find → Verify → Draft</strong>
        <p>No extra tabs. The app stays focused on finding exact source URLs, discovering contact paths, and preparing removal requests.</p>
      </div>
    </aside>
  );
};

export default Sidebar;
